// extracted by mini-css-extract-plugin
export default {"arrow":"Arrow_arrow__L64nB","head":"Arrow_head__vHT5K","tail":"Arrow_tail__9PKp1","body":"Arrow_body__GQm9w"};